export const SEARCH_ENDPOINT = '/search';
